export default __webpack_public_path__ + "static/media/git-hooks.a3d6905d.md";